import { render, staticRenderFns } from "./PendingsToSignByUser.vue?vue&type=template&id=6a474d04&scoped=true&lang=pug&"
import script from "./PendingsToSignByUser.vue?vue&type=script&lang=ts&"
export * from "./PendingsToSignByUser.vue?vue&type=script&lang=ts&"
import style0 from "./PendingsToSignByUser.vue?vue&type=style&index=0&id=6a474d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a474d04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VTooltip})
